import { render, staticRenderFns } from "./drawnArea.vue?vue&type=template&id=0b6fc2ba&scoped=true&"
import script from "./drawnArea.vue?vue&type=script&lang=js&"
export * from "./drawnArea.vue?vue&type=script&lang=js&"
import style0 from "./drawnArea.vue?vue&type=style&index=0&id=0b6fc2ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6fc2ba",
  null
  
)

export default component.exports